<div class="dialog-create=account dialog">

    <h3 mat-dialog-title class="text-center">Création de compte</h3>

    <p>Afin de vous connecter en tant qu'organisateur et gérer un évènement, vous devez vous créer un compte</p>

    <mat-dialog-content>
        <form [formGroup]="form" class="d-flex flex-column" id="login-form-wrapper" (submit)="onSubmit()">
            <mat-form-field appearance="outline">
                <mat-label>Prénom</mat-label>
                <input matInput type="text" placeholder="Identifiant" aria-label="fistname" aria-describedby="Prénom"
                    formControlName="firstName">
                @if (form.controls['firstName']?.touched && form.controls['firstName']?.invalid) {
                @if (form.controls['firstName'].hasError('required')) {
                <mat-error>Le prénom est obligatoire.</mat-error>
                }
                @if (form.controls['firstName'].hasError('minlength')) {
                <mat-error>Le prénom doit contenir au moins 2 caractères.</mat-error>
                }
                }
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Nom</mat-label>
                <input matInput type="text" placeholder="Nom" aria-label="lastName" aria-describedby="lastName"
                    formControlName="lastName">
            </mat-form-field>
            @if (form.controls['lastName']?.touched && form.controls['lastName']?.invalid) {
            @if (form.controls['lastName'].hasError('required')) {
            <mat-error>Le nom est obligatoire.</mat-error>
            }
            @if (form.controls['lastName'].hasError('minlength')) {
            <mat-error>Le nom doit contenir au moins 2 caractères.</mat-error>
            }
            }

            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput type="email" placeholder="Mail" aria-label="fistname" aria-describedby="Prénom"
                    formControlName="mail">
                @if (form.controls['mail']?.touched && form.controls['mail']?.invalid) {
                @if (form.controls['mail'].hasError('required')) {
                <mat-error>Le prénom est obligatoire.</mat-error>
                }
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Mot de passe</mat-label>
                <input matInput type="password" placeholder="Mot de passe" aria-label="password"
                    aria-describedby="password" formControlName="password">
                @if (form.controls['password']?.touched && form.controls['password']?.invalid) {
                @if (form.controls['password'].hasError('required')) {
                <mat-error>Le mot de passe est obligatoire.</mat-error>
                }
                @if (form.controls['password'].hasError('minlength')) {
                <mat-error>Le mot de passe doit contenir au moins 8 caractères.</mat-error>
                }
                }

            </mat-form-field>

            <button matButton="filled" [disabled]="!isFormValid" type="submit">Créer mon compte</button>

        </form>
    </mat-dialog-content>


    <div class="infos-followers small">
        La création de compte est uniquement destinée aux organisateurs et institutions. En tant que visiteur, vous
        pouvez
        consulter les resultats sans connexion.
    </div>
</div>